
define('ldsh!modules/accounts/companies/detail/form-company-services-template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

  if((typeof group !== 'undefined' && group.activeServiceGroup) && (service.get("id") !== 4)) { ;
__p += '\n<div class="row">\n    <div class="col-md-3">\n        <h4>\n            <strong class=" naranja i18n size13" data-i18n="ACCOUNTS.COMPANIES.LBL_SERVICE_' +
__e(service.get("id") ) +
'"> </strong>\n        </h4>\n\n    </div>\n    <div class="col-md-3">\n        ';
 if (service.get("activeServiceCompany")){ ;
__p += '\n          <div\n            id="activate-service-switch"\n            data-serviceId="' +
__e(service.get("id") ) +
'"\n            class="bg checked"\n            style="margin-top: 7px; margin-right: 7px"\n          ></div>\n          <label\n            id="activate-service-label_' +
__e(service.get("id") ) +
'"\n            style="margin-bottom: 7px; display:inline-block; vertical-align:middle; font-style:italic;"\n            class="i18n" data-i18n="ACCOUNTS.COMPANIES.LBL_ACTIVATE_SERVICE"\n          ></label>\n        ';
  } else { ;
__p += '\n          <div\n            id="activate-service-switch"\n            data-serviceId="' +
__e(service.get("id") ) +
'"\n            class="bg"\n            style="margin-top: 7px; margin-right: 7px"\n          ></div>\n          <label\n            id="activate-service-label_' +
__e(service.get("id") ) +
'"\n            style="margin-bottom: 7px; display:inline-block; vertical-align:middle; font-style:italic;"\n            class="i18n" data-i18n="ACCOUNTS.COMPANIES.LBL_DESACTIVATE_SERVICE"\n          ></label>\n        ';
 } ;
__p += '\n    </div>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

